import { render, staticRenderFns } from "./NextArrow.vue?vue&type=template&id=dd21d5f6&scoped=true&"
import script from "./NextArrow.vue?vue&type=script&lang=js&"
export * from "./NextArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd21d5f6",
  null
  
)

export default component.exports